const accidentResources = {
  en: {
    accident: {
      title: 'Accident insurance',
      calculator: 'Insurance Calculator',
      sum: 'Insurance amount per insured person',
      territory: 'Territory',
      period: 'Term of insurance',
      months: 'months',
      people: 'Number of insured',
      date: 'Contract start date',
      risk: 'Sports risk',
      premium: 'Prize',
      button: 'Calculate',
      'button.next': 'Next',
      'button.clear': 'ЕСЕПТЕУДІ ТАЗАЛАҢЫЗ',
      description: 'Description',
      subtitle: `Our lives are unpredictable, and not all "surprises" are pleasant. An accident can lead to
temporary or permanent disability. The life and health insurance program is the support that will
help you overcome difficult times.`,
      'acc1.title': 'Advantages',
      'acc1.html': `<ul style="margin: 0">
      <li>The insurance amount is up to 5 million tenge</li>
<li>One policy for the whole family (up to 10 insured persons can be included in the contract)</li>
<li>Is suitable for participation in competitions and sports</li>
<li>Compensation of medical expenses</li>
<li>The age of insurance is from 1 year to 65 years</li>
<li>Quick online registration</li>
</ul>`,
      'acc2.title': 'What insurance covers',
      'acc2.html': `<p style="margin: 0">Injury, disability, death of the insured as a result of an accident</p>`,
      'acc3.title': 'Insurance period',
      'acc3.html': `<p style="margin: 0">
  From six months to a year
</p>`,
      banner: {
        img: 'https://api.jgarant.kz/admin/media/Site/Banners/NS_2016%D1%85158_ru_01.07.2025.png',
        imgSm:
          'https://api.jgarant.kz/admin/media/Site/Banners/NS_343x100_ru_01.07.2025.png',
        imgDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/NS_2016%D1%85158_ru_01.07.2025.png',
        imgSmDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/NS_343x100_ru_01.07.2025.png',
      },
      РК: 'РК (Республика Казахстан)',
      СНГ: 'СНГ (Содружество Независимых Государств)',
      'РК и СНГ': 'РК и СНГ',
      'Весь мир': 'Весь мир',
      'Информация по страховке': 'Информация по страховке',
      'Срок страхования': 'Срок страхования',
      'Общая сумма страхования': 'Общая сумма страхования',
      ' месяцев': ' месяцев',
      'Количество застрахованных': 'Количество застрахованных',
      'Дата начала договора': 'Дата начала договора',
      'Спортивный риск': 'Спортивный риск',
      Территория: 'Территория',
      Премия: 'Премия',
      Оплатить: 'Оплатить',
      Да: 'Да',
      Нет: 'Нет',
    },
  },
  kz: {
    accident: {
      title: 'Жазатайым оқиғадан сақтандыру',
      calculator: 'Сақтандыру калькуляторы',
      sum: 'Әр сақтандырылушыға арналған сақтандыру сомасы',
      territory: 'Аумақ',
      period: 'Сақтандыру мерзімі',
      months: 'ай',
      people: 'Сақтандырылғандар саны',
      date: 'Шарттың басталатын күні',
      risk: 'Спорттық тәуекел',
      premium: 'Сыйақы',
      button: 'Есептеу',
      'button.next': 'Әрі қарай',
      'button.clear': 'Есептеуді тазалау',
      description: 'Сипаттамасы',
      subtitle: `Біздің өмірімізді болжау мүмкін емес және барлық «тосынсыйлар» да жағымды бола
бермейді. Жазатайым оқиға уақытша және тұрақты мүгедектікке әкелуі мүмкін. Өмірді
және денсаулықты қорғауды сақтандыру бағдарламасы - бұл қиын кезеңдерді жеңуге
көмектесетін қолдау.`,
      'acc1.title': 'Артықшылықтары',
      'acc1.html': `<ul style="margin: 0">
      <li>Сақтандыру сомасы 5 миллион теңгеге дейін</li>
<li>Бүкіл отбасы үшін бір полис (шартқа 10 сақтандырылушыға дейін қосуға болады)</li>
<li>Жарыстарға қатысу және спортпен шұғылдану үшін қолайлы</li>
<li>Емделу шығындарыан өтемақы</li>
<li>Сақтандыру жасы 1 жастан бастап 65 жасқа дейін</li>
<li>Онлайн жылдам рәсімдеу</li>
</ul>`,
      'acc2.title': 'Сақтандыру нені қамтиды',
      'acc2.html': `<p style="margin: 0">Жазатайым оқиға салдарынан сақтандырылушының жарақаттануы, мүгедектігі, қайтыс
болуы</p>`,
      'acc3.title': 'Сақтандыру мерзімі',
      'acc3.html': `<p style="margin: 0">
  Алты айдан бір жылға дейін
</p>`,
      banner: {
        img: 'https://api.jgarant.kz/admin/media/Site/Banners/NS_2016%D1%85158_kz_01.07.2025.png',
        imgSm:
          'https://api.jgarant.kz/admin/media/Site/Banners/NS_343x100_kz_01.07.2025.png',
        imgDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/NS_2016%D1%85158_kz_01.07.2025.png',
        imgSmDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/NS_343x100_kz_01.07.2025.png',
      },
      РК: 'ҚР (Қазақстан Республикасы)',
      СНГ: 'ТМД (Тәуелсіз Мемлекеттер Достастығы)',
      'РК и СНГ':
        'ҚР (Қазақстан Республикасы) және ТМД (Тәуелсіз Мемлекеттер Достастығы)',
      'Весь мир': 'Бүкіл әлем',
      'Информация по страховке': 'Сақтандыру туралы ақпарат',
      'Срок страхования': 'Сақтандыру мерзімі',
      'Общая сумма страхования': 'Сақтандырудың жалпы сомасы',
      ' месяцев': ' ай',
      'Количество застрахованных': 'Сақтандырылғандардың саны',
      'Дата начала договора': 'Шарттың басталу күні',
      'Спортивный риск': 'Спорттық тәуекел',
      Территория: 'Аймақ',
      Премия: 'Сыйлықақысы',
      Оплатить: 'Төлеу',
      Да: 'Ия',
      Нет: 'Жоқ',
    },
  },
  ru: {
    accident: {
      title: 'Страхование от несчастного случая',
      calculator: 'Калькулятор страхования',
      sum: 'Страховая сумма на одного застрахованного',
      territory: 'Территория страхования',
      period: 'Срок страхования',
      months: 'месяцев',
      people: 'Количество застрахованных',
      date: 'Дата начала договора',
      risk: 'Спортивный риск',
      premium: 'Премия',
      button: 'Рассчитать',
      'button.next': 'Далее',
      'button.clear': 'ОЧИСТИТЬ РАСЧЕТ',
      description: 'Описание',
      subtitle: `Наша жизнь непредсказуема и не все «сюрпризы» бывают приятными. Несчастный случай
может стать причиной временной и постоянной нетрудоспособности. Страховая
программа защиты жизни и здоровья – это поддержка, которая поможет преодолеть
трудные времена.`,
      'acc1.title': 'Преимущества',
      'acc1.html': `<ul style="margin: 0">
      <li>Страховая сумма до 5 миллионов тенге</li>
<li>Один полис для всей семьи (в договор можно включить до 10 застрахованных)</li>
<li>Подходит для участия в соревнованиях и занятия спортом</li>
<li>Компенсация расходов на лечение</li>
<li>Возраст страхования от 1 года до 65 лет</li>
<li>Быстрое оформление онлайн</li>
</ul>`,
      'acc2.title': 'Что покрывает страховка',
      'acc2.html': `<p style="margin: 0">Травма, инвалидность, летальный исход застрахованного в результате несчастного случая.</p>`,
      'acc3.title': 'Срок страхования',
      'acc3.html': `<p style="margin: 0">
  От шести месяцев до года
</p>`,
      banner: {
        img: 'https://api.jgarant.kz/admin/media/Site/Banners/NS_2016%D1%85158_ru_01.07.2025.png',
        imgSm:
          'https://api.jgarant.kz/admin/media/Site/Banners/NS_343x100_ru_01.07.2025.png',
        imgDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/NS_2016%D1%85158_ru_01.07.2025.png',
        imgSmDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/NS_343x100_ru_01.07.2025.png',
      },
      РК: 'РК (Республика Казахстан)',
      СНГ: 'СНГ (Содружество Независимых Государств)',
      'РК и СНГ': 'РК и СНГ',
      'Весь мир': 'Весь мир',
      'Информация по страховке': 'Информация по страховке',
      'Срок страхования': 'Срок страхования',
      'Общая сумма страхования': 'Общая сумма страхования',
      ' месяцев': ' месяцев',
      'Количество застрахованных': 'Количество застрахованных',
      'Дата начала договора': 'Дата начала договора',
      'Спортивный риск': 'Спортивный риск',
      Территория: 'Территория',
      Премия: 'Премия',
      Оплатить: 'Оплатить',
      Да: 'Да',
      Нет: 'Нет',
    },
  },
};

export default accidentResources;
